import Section from './Section';

export { default as SectionTheme } from './Section.style';
export default Section;
